import React from 'react';

import useUser from 'hooks/useUser';

import UnauthorizedPage from 'components/layout/UnauthorizedPage';
import AdminUsers from './admin';

const UsersPage = () => {
  const { isAdmin, isBdataAmin, isBcAdmin } = useUser();
  return (isAdmin || isBdataAmin || isBcAdmin) ? <AdminUsers /> : <UnauthorizedPage />;
};

export default UsersPage;
